import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Image, Link, Text } from '@chakra-ui/react';

import WhatsImage from 'src/img/whats.svg';
import { createWhatsappUrl } from 'src/utils/whatsapp';

import messages from '../messages';

const wrapWithLink = (node, href, options) => (
  <Link href={href} isExternal {...options}>
    {node}
  </Link>
);

export const SupportInformation = () => {
  const intl = useIntl();

  const supportUrl = createWhatsappUrl({
    message: intl.formatMessage(messages.whatsappDefaultMessage),
  });

  return (
    <Box
      p={4}
      my={2}
      shadow="md"
      borderWidth="1px"
      display="flex"
      alignItems="center"
      gap={2}
      role="complementary"
    >
      <Text fontSize="md" fontWeight={500}>
        <FormattedMessage
          {...messages.contactInfo}
          values={{
            a: text => wrapWithLink(text, supportUrl, { color: 'blue.400' }),
          }}
        />
      </Text>
      {wrapWithLink(<Image src={WhatsImage} maxW={32} />, supportUrl, {
        width: 'auto',
      })}
    </Box>
  );
};
